<template>
  <div class="general">
    <!-- <div class="general__option">
    <div class="general__title">
      <span class="priority">*</span>
      Remuneración Mínima Vital (RMV)
    </div>
    <input type="text" class="general__input" v-model="ldata.rmv">
  </div>
  <div class="general__option">
    <div class="general__title">
      <span class="priority">*</span>
      Unidad Impositiva Tributaria (UIT)
    </div>
    <input type="text" class="general__input" v-model="ldata.uit">
  </div> -->
    <md-field>
      <label>Días de trabajo especiales</label>
    </md-field>
    <md-checkbox v-model="ldata.worksSaturdays" :value="true">Sábado</md-checkbox>
    <br />
    <md-checkbox v-model="ldata.worksSundays" :value="true">Domingo</md-checkbox>
    <br />
    <md-button class="md-raised md-accent c-emergencia__sgte" @click="save"
      >Guardar</md-button
    >
    <!-- <md-field>
    <label>Unidad Impositiva Tributaria (UIT)</label>
    <md-input v-model="ldata.uit" required disabled/>
  </md-field>

  <md-field>
    <label>Empresa</label>
    <md-input v-model="ldata.name" disabled required/>
  </md-field>

  <md-field>
    <label>Dirección</label>
    <md-input v-model="ldata.address" required/>
  </md-field>

  <md-field>
    <label>Registro Único de Contribuyentes (RUC)</label>
    <md-input v-model="ldata.ruc" required disabled/>
  </md-field>

  <md-field>
    <label>Correo de contacto</label>
    <md-input v-model="ldata.email" required/>
  </md-field>

  <md-field>
    <label>Teléfono de contacto</label>
    <md-input v-model="ldata.phone" required/>
  </md-field> -->
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  created() {
    if (this.value.id) {
      this.ldata = JSON.parse(JSON.stringify(this.value));
    }
  },
  data() {
    return {
      ldata: {},
    };
  },
  methods: {
    save() {
      this.$store.dispatch("putBusiness", this.ldata).then((res) => {
        if (res.status == 200) {
          this.$toasted.success("Datos guardados", {
            theme: "bubble",
            position: "top-right",
            duration: 1000,
            className: "short-message",
          });
        }
        if (res.status >= 400) {
          this.$toasted.show("Ha sucedido un problema", {
            theme: "bubble",
            position: "top-right",
            duration: 5000,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS
.priority {
  color: $b-orange;
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}
//7-TRUMPS
//vue-material
.md-field {
  width: 18rem;
  // margin: 0 2rem 2rem 24px;

  &.md-theme-default {
    label {
      color: rgba($b-emph, 0.6);
      &::after {
        color: $b-blue;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-orange;
    }
    &.md-focused {
      label {
        color: $b-orange;
      }
    }

    &.md-invalid {
      label {
        color: $b-blue;
      }
      &::after {
        background-color: $b-blue;
      }
      .md-error {
        color: $b-blue;
      }
    }
  }
}

.general {
  padding-top: 2rem;
  &__option {
    margin-bottom: 1.5rem;
    @include mq($sm) {
      width: 30rem;
    }
  }
  &__title {
    color: $b-emph;
    font-size: 1.2rem;
  }
  &__input {
    height: 3rem;
    display: block;
    width: 100%;
    border-radius: 3px;
    border: 1px solid #d7dae2;
    box-shadow: 0px 2px 3px rgba(#000, 0.05);
    padding-left: 1rem;
    margin-top: 0.5rem;
  }
}
.c-emergencia__sgte {
  margin-left: 0px;
}
</style>
